// extracted by mini-css-extract-plugin
export default {"storyTimeline":"c-a_gy","storyTimeline__item":"c-a_gz","storyTimeline__item_complete":"c-a_gA","storyTimeline__item_withProgress":"c-a_gB"};